import styles from "./PlanList.module.scss";
import { Plan } from "../../../apis/subscriptionApi";
import PlanRow from "./PlanRow";

function DeletedPlanList({
  plans,
  refetchPlans,
}: {
  plans: Plan[];
  refetchPlans: VoidFunction;
}) {
  const deletedPlans = plans
    .filter((plan) => !plan.active)
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <ul className={styles.list}>
      {deletedPlans.map((plan) => {
        return (
          <PlanRow key={plan.planUuid} plan={plan} refetchPlans={refetchPlans} />
        );
      })}
    </ul>
  );
}

export default DeletedPlanList;
